<nz-layout class="app-layout">
  <nz-sider nzCollapsible [(nzCollapsed)]="isCollapsed" nzBreakpoint="md" nzWidth="250px" [nzTrigger]="null" class="side-bar">
    <div class="topCorner" style="display: flex; justify-content: center; align-items: center; background-color: white;">
        <div *ngIf="!isCollapsed" style="width: 100%; display: flex; justify-content: center;padding: 5px;">
          <img  src="./../../../../../assets/images/logo.png" alt="" style="width: 80%;">
        </div>
        <div *ngIf="isCollapsed" style="width: 100%; display: flex; justify-content: center;">
          <img  src="./../../../../../assets/images/logo.png" style="height: 40px; width: 40px; object-fit: contain;" alt="">
        </div>
    </div>

    <perfect-scrollbar style="width: 100%; max-height: calc(100vh - 55px);">
      <ul nz-menu nzTheme="light" nzMode="inline" *ngIf="!isCollapsed">
        <li class="user-header">
          <img src="../../../../../assets/images/user-logo.png" class="img-circle user-image" alt="User Image">

          <h4 class="user-name theme-text"> {{userProfile.fullname}}
          </h4>
          <p class="user-name user-role">
            <small class="user-role"><b>{{userRole | titlecase}}</b></small>
          </p>
        </li>
      </ul>
      <ul nz-menu nzTheme="light" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
        <app-sider [isCollapsed]="isCollapsed"></app-sider>
      </ul>
    </perfect-scrollbar>
  </nz-sider>

  <nz-layout style="background-color: #F0F5F7;">
    <div style="position: sticky; top: 0px; z-index: 99;">
      <app-header (buka)="sidebarOpen($event)" ></app-header>
    </div>

    <nz-content>
      <router-outlet></router-outlet>
    </nz-content>

  </nz-layout>
</nz-layout>
